import { contactEditFormSchema } from './update-form.js';
import { updateContactInputSchema } from './update-input.js';
export const CONTACT_EDIT_FORM_FIELD_KEYS = Object.keys(contactEditFormSchema.shape);
/** Prisma update payload: only keys explicitly present in the patch (undefined omits). */
export function buildContactUpdateData(input) {
    return {
        ...(input.contactName !== undefined ? { contactName: input.contactName } : {}),
        ...(input.title !== undefined ? { title: input.title } : {}),
        ...(input.email !== undefined ? { email: input.email } : {}),
        ...(input.phone !== undefined ? { phone: input.phone } : {}),
        ...(input.preference !== undefined ? { preference: input.preference } : {}),
        ...(input.defaultFlag !== undefined ? { defaultFlag: input.defaultFlag } : {}),
    };
}
export function toUpdateContactInputFromDirtyForm(values, dirtyFields) {
    const patch = {};
    for (const key of CONTACT_EDIT_FORM_FIELD_KEYS) {
        if (dirtyFields[key]) {
            Object.assign(patch, { [key]: values[key] });
        }
    }
    return toUpdateContactInput(patch);
}
export function toUpdateContactInput(values) {
    const parsed = contactEditFormSchema.parse(values);
    const input = {};
    if (parsed.contactName !== undefined) {
        input.contactName = parsed.contactName;
    }
    if (parsed.title !== undefined) {
        input.title = parsed.title;
    }
    if (parsed.email !== undefined) {
        input.email = parsed.email;
    }
    if (parsed.phone !== undefined) {
        input.phone = parsed.phone;
    }
    if (parsed.preference !== undefined) {
        input.preference = parsed.preference;
    }
    if (parsed.defaultFlag !== undefined) {
        input.defaultFlag = parsed.defaultFlag;
    }
    return updateContactInputSchema.parse(input);
}
//# sourceMappingURL=update-mapper.js.map